import { compose, filter, is, isNil, join, map, not } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { getMessage } from '@gef-ui/localization/messages';

export const joinString = (separator, values) => {
	const joinedStrings = join(separator, filter(compose(not, isNilOrEmpty), values ? values : []));
	if (joinedStrings === separator) {
		return '';
	} else {
		return joinedStrings;
	}
};

export const toString = (value) => emptyString(String(!isNil(value) ? value : ''), '');

export const emptyString = (value, alternative = '---') => {
	if (is(Array, value) || is(Object, value)) {
		return map((v) => (isNilOrEmpty(v) ? alternative : v), value);
	}
	return isNilOrEmpty(value) ? alternative : value;
};

export const booleanToString = (value) => (value ? getMessage('common:yes') : getMessage('common:no'));

export const generateFullNameOrBusinessName = (businessName, surname, firstName) => {
	return businessName ? businessName : joinString(' ', [surname, firstName]);
};
